import { render, staticRenderFns } from "./PaymentGuard.vue?vue&type=template&id=bd8fb79a"
import script from "./PaymentGuard.vue?vue&type=script&lang=ts"
export * from "./PaymentGuard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd8fb79a')) {
      api.createRecord('bd8fb79a', component.options)
    } else {
      api.reload('bd8fb79a', component.options)
    }
    module.hot.accept("./PaymentGuard.vue?vue&type=template&id=bd8fb79a", function () {
      api.rerender('bd8fb79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/guards/PaymentGuard.vue"
export default component.exports